import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import ButtonAsync from '../button/button-async'
import Button from '../button/button'
import Text from '../form/form-text'

//https://github.com/fengyuanchen/cropperjs
import Cropper from 'cropperjs';

import './imageCropper.styl'
import './imageCropper-cropper.styl'

// https://github.com/TAPP-TV/react-cropperjs/blob/master/src/react-cropper.js
// https://github.com/TAPP-TV/react-cropperjs/blob/master/example/index.js
// OR
// https://tympanus.net/codrops/2014/10/30/resizing-cropping-images-canvas/

//http://jsfiddle.net/handtrix/YvQ5y/
class ImageCropper extends React.Component {
    // static FUNC_NAMES = ['build', 'built', 'cropstart', 'cropmove', 'cropend', 'crop'];

    constructor(props){
        super(props);
        this.state = {}
    }

    componentWillUnmount() {
        if (this.cropper) {
            // Destroy the cropper, this makes sure events such as resize are cleaned up and do not leak
            this.cropper.destroy();
            // While we're at it remove our reference to the jQuery instance
            //   delete this.$img;
        }
    }

    componentDidMount() {
        this.options = {}
        // ImageCropper.FUNC_NAMES.forEach( name => options[name]=this[name].bind(this))
        this.options.ref='cropper'
        this.options.zoomable = false
        this.options.scalable = false
        this.options.center = true
        this.options.guides = false
        this.options.modal = true
        // this.options.style={height: '100%', width: '100%'}
        this.options.cropBoxMovable = true
        this.options.cropBoxResizable = true
        this.options.viewMode = 0

        // options.preview = '.image-panel-preview';
        this.options.preview = false
        this.options.crop = this.cropping.bind(this)

        this.options.minCropBoxWidth = 0;
        this.options.minCropBoxHeight = 0;

        this.cropper = new Cropper(this.image, this.options);
        this.cropper.setData(this.props.cropBoxData);
    }

    componentDidUpdate(prevProps, prevState) {
        !this.cropper && (this.cropper = new Cropper(this.image, this.options));
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.cropper && this.cropper.setData(nextProps.cropBoxData);
        this.setState({})
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(!this.cropper) {
            return true;
        }
        let { cropBoxData } = nextProps;
        let { x, y, width, height } = this.cropper.getData(true);

        return !(cropBoxData.x === x &&
            cropBoxData.y === y &&
            cropBoxData.width === width &&
            cropBoxData.height === height)
    }

    cropping(e) {
        Object.keys(e.detail).forEach(i => e.detail[i] = Number.parseInt(e.detail[i]))
        this.imageCroppedDetails = e.detail
        this.props.cropping(e.detail)
    }

    crop() {
        this.props.cropping({cropped: true});
        this.state.imageCropped = this.cropper.getCroppedCanvas().toDataURL()
        this.forceUpdate()
    }

    save() {
        this.props.save({details: this.imageCroppedDetails, image: this.state.imageCropped} );
        return Promise.resolve();
    }

    cancel() {
        this.cropper = null;
        this.setState({
            imageCropped: false
        });
        this.props.cropping({cropped: false} );
    }

    render() {
        let { props, state } = this;
        let { source } = props;
        let { imageCropped  } = state;

        return (<div className="image-cropper">
            {!imageCropped && <div className="image-cropper-original" crossOrigin={null} src={null} alt={null} ref='cropper'>
                <img ref={ i => this.image = i } src={source} crossOrigin=""/>
            </div>}
            {imageCropped && <div className="image-cropper-preview">
                <img src={imageCropped} />
            </div>}
            <div className="page-bottom-layout">
                { !imageCropped && <Button onClick={ this.crop.bind(this) } label="app.validate" /> }
                { imageCropped && <Button onClick={ this.save.bind(this) } label="app.validate" labelError="app.error" /> }
                { imageCropped && <Button onClick={ this.cancel.bind(this) } label="app.cancel" /> }
            </div>
        </div>)
    }
}

//http://roadmanfong.github.io/react-cropper/
// https://www.google.fr/search?q=react+cropperjs+usage+smaples&oq=react+cropperjs+usage+smaples&aqs=chrome..69i57.4519j0j1&sourceid=chrome&ie=UTF-8
//https://github.com/roadmanfong/react-cropper/blob/master/example/src/Demo.jsx
//https://github.com/roadmanfong/react-cropper/blob/master/src/react-cropper.jsx
ImageCropper.propTypes = {
    source: PropTypes.string.isRequired,
    save: PropTypes.func,
    cropping: PropTypes.func,

    cropBoxData: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number
    })
}
ImageCropper.defaultProps = {
    save: e => e,
    crop: e => e,
    cropping: e => e
}

export default injectIntl(ImageCropper)
